package co.uk.sacursoftware.ssinventory.ui

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.nestedscroll.NestedScrollConnection
import androidx.compose.ui.input.nestedscroll.NestedScrollSource
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.datetime.LocalDate

class ScrollCollapseState(private val rangePx: Float = 140f) {
    var fraction by mutableFloatStateOf(0f)

    fun expand() {
        fraction = 0f
    }

    fun connection(atTop: () -> Boolean): NestedScrollConnection = object : NestedScrollConnection {
        override fun onPreScroll(available: Offset, source: NestedScrollSource): Offset {
            if (available.y < 0f && fraction < 1f) {
                val next = ((fraction * rangePx) - available.y).coerceIn(0f, rangePx)
                val consumed = next - fraction * rangePx
                fraction = next / rangePx
                return Offset(0f, -consumed)
            }
            return Offset.Zero
        }

        override fun onPostScroll(consumed: Offset, available: Offset, source: NestedScrollSource): Offset {
            if (available.y > 0f && fraction > 0f && atTop()) {
                val next = ((fraction * rangePx) - available.y).coerceIn(0f, rangePx)
                val consumedY = fraction * rangePx - next
                fraction = next / rangePx
                return Offset(0f, consumedY)
            }
            return Offset.Zero
        }
    }
}

@Composable
fun rememberScrollCollapse(rangePx: Float = 140f): ScrollCollapseState {
    return remember { ScrollCollapseState(rangePx) }
}

@Composable
fun CollapsingDateTabs(
    dates: List<LocalDate>,
    selectedDate: LocalDate,
    today: LocalDate,
    collapse: Float,
    onDateSelected: (LocalDate) -> Unit,
    onExpand: () -> Unit,
) {
    if (dates.size <= 1) return
    if (collapse >= 0.78f) {
        val tabColor = dateTabColor(selectedDate, today)
        Surface(
            modifier = Modifier.fillMaxWidth().clickable(onClick = onExpand),
            color = MaterialTheme.colorScheme.surfaceVariant
        ) {
            Text(
                text = "${selectedDate.dayOfWeek.name.take(3)} ${selectedDate.toString().takeLast(5)}",
                modifier = Modifier.padding(horizontal = 16.dp, vertical = 10.dp),
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.Bold,
                color = tabColor
            )
        }
    } else {
        ScrollableTabRow(
            selectedTabIndex = dates.indexOf(selectedDate).coerceAtLeast(0),
            edgePadding = 0.dp,
            containerColor = MaterialTheme.colorScheme.surfaceVariant,
            contentColor = MaterialTheme.colorScheme.primary,
            divider = {}
        ) {
            dates.forEach { date ->
                val tabColor = dateTabColor(date, today)
                Tab(
                    selected = selectedDate == date,
                    onClick = { onDateSelected(date) },
                    text = {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            Text(date.dayOfWeek.name.take(3), style = MaterialTheme.typography.labelSmall, color = tabColor)
                            Text(date.toString().takeLast(5), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = tabColor)
                        }
                    }
                )
            }
        }
    }
}

@Composable
private fun dateTabColor(date: LocalDate, today: LocalDate): Color = when {
    date < today -> Color.Gray
    date == today -> Color(0xFFE52321)
    else -> MaterialTheme.colorScheme.onSurface
}

@Composable
fun ToolbarPlusButton(onClick: () -> Unit) {
    IconButton(onClick = onClick) {
        Text(
            "+",
            style = MaterialTheme.typography.headlineSmall,
            fontWeight = FontWeight.Bold,
            color = MaterialTheme.colorScheme.onSurface
        )
    }
}
